import React, { useMemo, useState } from 'react';
import { FiFolder, FiX } from 'react-icons/fi';

function FolderNode({ folder, childrenByParent, depth, selectedId, onSelect, excludeIds }) {
  const kids = (childrenByParent.get(folder.id) || []).filter(
    (c) => c.kind === 'folder' && !excludeIds.has(c.id)
  );
  const selected = selectedId === folder.id;
  return (
    <div className="todo-move-node">
      <button
        type="button"
        className={`todo-move-row${selected ? ' is-selected' : ''}`}
        style={{ paddingLeft: 12 + depth * 16 }}
        onClick={() => onSelect(folder.id)}
      >
        <FiFolder />
        <span>{folder.title}</span>
      </button>
      {kids.map((child) => (
        <FolderNode
          key={child.id}
          folder={child}
          childrenByParent={childrenByParent}
          depth={depth + 1}
          selectedId={selectedId}
          onSelect={onSelect}
          excludeIds={excludeIds}
        />
      ))}
    </div>
  );
}

export default function TodoMovePicker({ items, movingItem, onClose, onMove }) {
  const excludeIds = useMemo(() => {
    const ids = new Set([movingItem.id]);
    const byParent = new Map();
    items.filter((item) => item.user_id === movingItem.user_id).forEach((item) => {
      const key = item.parent_id ?? 'root';
      if (!byParent.has(key)) byParent.set(key, []);
      byParent.get(key).push(item);
    });
    const walk = (id) => {
      const kids = byParent.get(id) || [];
      kids.forEach((k) => {
        ids.add(k.id);
        walk(k.id);
      });
    };
    walk(movingItem.id);
    return ids;
  }, [items, movingItem]);

  const childrenByParent = useMemo(() => {
    const map = new Map();
    items.filter((item) => item.user_id === movingItem.user_id).forEach((item) => {
      if (item.kind !== 'folder' || excludeIds.has(item.id)) return;
      const key = item.parent_id ?? 'root';
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(item);
    });
    return map;
  }, [items, excludeIds, movingItem.user_id]);

  const roots = childrenByParent.get('root') || [];
  const [selectedId, setSelectedId] = useState(
    movingItem.parent_id == null ? 'root' : movingItem.parent_id
  );

  return (
    <div className="todo-modal-backdrop" onClick={onClose} role="presentation">
      <div className="todo-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Move item">
        <div className="todo-modal-header">
          <h2>Move “{movingItem.title}”</h2>
          <button type="button" className="todo-icon-btn" onClick={onClose} aria-label="Close">
            <FiX />
          </button>
        </div>
        <div className="todo-move-list">
          {movingItem.can_manage_sharing && (
            <button
              type="button"
              className={`todo-move-row${selectedId === 'root' ? ' is-selected' : ''}`}
              onClick={() => setSelectedId('root')}
            >
              <FiFolder />
              <span>Home</span>
            </button>
          )}
          {roots.map((folder) => (
            <FolderNode
              key={folder.id}
              folder={folder}
              childrenByParent={childrenByParent}
              depth={1}
              selectedId={selectedId}
              onSelect={setSelectedId}
              excludeIds={excludeIds}
            />
          ))}
        </div>
        <div className="todo-modal-actions">
          <button type="button" className="todo-btn todo-btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="todo-btn todo-btn-primary"
            onClick={() => onMove(selectedId === 'root' ? null : selectedId)}
          >
            Move here
          </button>
        </div>
      </div>
    </div>
  );
}
